import { useNuxtApp } from '#app';
import { downloadFileCrossBrowser } from '@/utils/helpers/script';
import {
  localStorageSetItem,
  localStorageGetObject,
  localStorageRemoveItem
} from '~/utils/helpers/store';

export const useDownLoadMaterial = () => {
  const { $modal, $msal, $router } = useNuxtApp();
  const { t } = useI18n();
  const route = useRoute();
  const store = useStore();
  const loading = ref(null);
  const message = ref({});
  const dataReproduce = ref({});
  const videoPlayer = useTemplateRef('videoPlayer');
  const videoPlayerMaterial = useTemplateRef('videoPlayerMaterial');

  const enrolled = computed(() => store.getters['profile/getByField']('enrolled'));
  const course = computed(() => store.getters['strapi/getByField']('events') || {});
  const dynamicForm = computed(() => store.getters['profile/getByField']('dynamicForm'));

  const onClickPdf = (url, index, showAlways = false) => {
    dataReproduce.value = { isFile: true, url, index };
    enrolled.value || showAlways ? downloadMaterial(url, index, showAlways) : enrollEventPlay();
    localStorageRemoveItem('material');
  };

  const downloadMaterial = async (url, index) => {
    loading.value = index;
    const slug = route.params.slug;
    try {
      const uri = await store.dispatch('profile/fileDownload', {
        pathParam: 'getCourseMaterialFile',
        slug: `${slug}/${url}`
      });
      await store.dispatch('profile/checkFileExist', {
        uri
      });
      downloadFileCrossBrowser(uri);
    } catch (err) {
      console.error(err);
      message.value = {
        text: t('message.error.errorFile'),
        type: 'error'
      };
      await $modal.open('errorFileDownload');
    } finally {
      loading.value = null;
    }
  };

  const onClickMultimedia = (url, index, showAlways = false) => {
    dataReproduce.value = { isFile: false, url, index };
    enrolled.value || showAlways ? playVideo(url) : enrollEventPlay();
    localStorageRemoveItem('material');
  };

  const playVideo = url => {
    const isYoutube = dataReproduce.value.url?.includes('youtube') || url?.includes('youtube');
    const video =
      url && /[?#&]t=/.test(url)
        ? `${isYoutube ? dataReproduce.value.url.replace('youtube', 'youtube-nocookie') : dataReproduce.value.url}${/[?]/.test(dataReproduce.value.url) ? '&' : isYoutube ? '?' : '#'}start=${url.match(/[?#&]t=(\d+)/)[1]}`
        : dataReproduce.value.url;
    if (dataReproduce.value.isFile) {
      videoPlayer.value?.openPlayer(url);
    } else {
      videoPlayerMaterial.value?.openPlayer(video);
    }
  };

  const redirectLogin = (file = false, url, index) => {
    localStorageSetItem('material', { type: file, url, index });
    $msal.signIn(route.fullPath);
  };

  const subscribePastEvent = async () => {
    try {
      if (dynamicForm.value?.length) {
        $router.push({
          path: REGISTER_BASE_URL,
          query: { type: 'event', step: 4, slug: route.params.slug }
        });
      } else if (course.value?.event_features?.course_partner === 'feder') {
        $modal.open('confirm-subscription');
      } else if (!enrolled.value) {
        const enrollEvent = localStorageGetObject('enrollEvent');
        const response = await store.dispatch('profile/subscribeEvent', {
          additionalInfo: enrollEvent?.additionalInfo,
          modality: enrollEvent?.modality,
          isFree: false
        });
        return response;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const enrollEventPlay = async () => {
    try {
      await subscribePastEvent();
    } catch (err) {
      console.error(err);
      message.value = {
        text: t('message.error.errorFile'),
        type: 'error'
      };
      await $modal.open('errorFileDownload');
    } finally {
      loading.value = false;
    }
  };

  watch(enrolled, val => {
    if (val && dataReproduce.value?.url) {
      dataReproduce.value?.isFile
        ? downloadMaterial(dataReproduce.value?.url, dataReproduce.value?.index)
        : playVideo(dataReproduce.value?.url);
    }
  });

  return {
    loading,
    message,
    course,
    enrolled,
    playVideo,
    onClickPdf,
    videoPlayer,
    dataReproduce,
    redirectLogin,
    dynamicForm,
    enrollEventPlay,
    onClickMultimedia,
    videoPlayerMaterial
  };
};
